import { ShopIcon } from '@/components/icons'
import { useAppSelector } from '@/hooks/useRedux'
import { appSelector } from '@/pages/home/selectors'

export const Sponsors = () => {
  const { sponsorDetails } = useAppSelector(appSelector)

  const navigateToLink = () => {
    window.open(sponsorDetails?.link, '_blank')
  }

  return (
    <>
      {sponsorDetails?.showBanner ? (
        <div
          className="min-h-[45px] bg-darkNavy flex justify-center cursor-pointer items-center py-2 px-6 md:py-0 md:px-0"
          onClick={navigateToLink}
        >
          <ShopIcon />
          <span className="text-white text-sm font-medium ml-4">{sponsorDetails.message}</span>
        </div>
      ) : (
        <></>
      )}
    </>
  )
}
